import * as React from "react";
import theme from "../../theme";
import { makeStyles } from "@material-ui/core";
import { TableBody, TableHead, TableRow, Table, TableCell } from "@material-ui/core";
import PageLoading from "./pageLoading";
import ChatTabItem from "./chatTabItem";

const useStyles = makeStyles((th) => ({
  supportPopup: {
    marginBottom: th.spacing(1),
    // padding: th.spacing(2),
    // maxWidth: 260,
    width: "380px",
    height: "380px",
    backgroundColor: th.palette.background.paper,
    boxShadow: th.shadows[3],
    borderRadius: "15px 15px 0 0"
  },
  tabHeader: {
    padding: "10px 10px",
    display: "flex",
    justifyContent: "center",
    width: "100%",
    // borderBottom: `2px solid ${theme.colors.MintGreen}`
  },
  header: {
    fontWeight: "bolder"
  },
  sep: {
    borderColor: theme.colors.DodgerBlue,
    marginBottom: 0
  },
  supportBody: {
    // padding: "0 12px",
    overflowY: "scroll",
    maxHeight: "70%"
  },
  supportBodyTab: {
    backgroundColor: theme.colors.Zumthor,
    color: theme.colors.DodgerBlue
  }
}))

export default function SmallChatContainer({
  chatHeader = "Messages",
  current,
  setCurrent,
  showLoader = false,
  data = [],
  chatResponseAction = (chatIdentifier, response) => {
    console.log("ran")
  },
  chatProcessingAction = (chatIdentifier, action) => {

  }
}) {
  const classes = useStyles()
  const handleClick = (cId) => {

  }
  return (
    <div className={classes.supportPopup}>
      {
        showLoader ? <PageLoading /> : (
          <>
            <div className={classes.tabHeader}>
              <header className={classes.header}>{chatHeader}</header>
            </div>
            <hr className={classes.sep} />
            <SupportStatusTable
              current={current}
              setCurrent={setCurrent}
            />
            <div className={classes.supportBody}>
              {data?.map((c, i) => (
                <ChatTabItem
                  key={i}
                  name={c?.employee?.first_name}
                  message={c?.description}
                  time={new Date(c?.created_at).toLocaleDateString()}
                  image={c?.image}
                  chatIdentifier={c?.id}
                  onClick={handleClick}
                  responseAction={chatResponseAction}
                  allowMarker={c?.status !== "CLOSED"}
                  processingAction={c?.status !== "PROCESSING" && chatProcessingAction}
                />
              ))}
            </div>
          </>
        )
      }
    </div>
  )
}

function SupportStatusTable({ current, setCurrent }) {
  const classes = useStyles();

  return (
    <Table className={classes.supportBodyTab}>
      <TableHead>
        <TableRow>
          <TableCell
            onClick={() => setCurrent("opened")}
            style={{
              cursor: "pointer",
              backgroundColor: current === "opened" ? theme.colors.DodgerBlue : undefined,
              color: current === "opened" ? theme.colors.White : undefined
            }}
          >
            <strong>Opened</strong>
          </TableCell>
          <TableCell
            onClick={() => setCurrent("processing")}
            style={{
              cursor: "pointer",
              backgroundColor: current === "processing" ? theme.colors.DodgerBlue : undefined,
              color: current === "processing" ? theme.colors.White : undefined
            }}
          >
            <strong>Processing</strong>
          </TableCell>
          <TableCell
            onClick={() => setCurrent("closed")}
            style={{
              cursor: "pointer",
              backgroundColor: current === "closed" ? theme.colors.DodgerBlue : undefined,
              color: current === "closed" ? theme.colors.White : undefined
            }}
          >
            <strong>Closed</strong>
          </TableCell>
        </TableRow>
      </TableHead>
    </Table>
  );
}


